import { render } from "./AddHunanBack.vue?vue&type=template&id=475ea61e&scoped=true"
import script from "./AddHunanBack.vue?vue&type=script&lang=js"
export * from "./AddHunanBack.vue?vue&type=script&lang=js"

import "./AddHunanBack.vue?vue&type=style&index=0&id=475ea61e&lang=scss&scoped=true"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475ea61e"]])

export default __exports__